'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
import etask from 'zetask';
import iutil from '../install_util';
import www_util from 'hola_pub_util';
import { install } from '../install';
var assign = Object.assign;
var install_started = false;
export var start_install = (opt = {}, on_start) => etask(function* () {
  if (install_started) return;
  install_started = true;
  this.finally(() => install_started = false);
  var ctx = opt.ctx;
  if (!ctx) ctx = yield iutil.init_ctx(opt);
  delete opt.ctx;
  if (on_start) on_start(opt, ctx);
  opt.skip = assign(opt.skip || {}, {
    choose_plan: (opt.skip || {}).choose_plan || opt.flow && opt.flow != 'vpn'
  });
  install.install_flow(document.body, ctx, opt);
});
var ga_send = (type, category, action, label, non_interaction) => {
  window.ga(function () {
    window.ga('send', {
      hitType: type,
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      nonInteraction: non_interaction
    });
  });
};
export var get_download = flow => ev => {
  ev.preventDefault();
  var install_src = www_util.get_click_data(ev.target).id;
  ga_send('event', 'www_site_load', 'click_' + flow, install_src);
  www_util.perr({
    id: 'www_site_load_clicked',
    info: location.href,
    product_type: flow,
    source: install_src
  });
  start_install({
    flow: flow,
    install_src: install_src
  });
};